export default __webpack_public_path__ + "static/media/course2.9d8f8c93.jpg";